<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">list</mat-icon>
        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{'main.marketplaceCategory' | translate}}
          </div>
        </div>
      </div>
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <div>
        <button mat-raised-button
          [routerLink]="'/pages/settings/marketplaceCategory/new'"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'main.add' | translate}}</span>
        </button>
      </div>

    </div>


    <div class="content-card mat-white-bg">
      <!-- / SEARCH -->
      <div class="categories">
        @if (marketplaceCategories.length) {
          @for (mp of marketplaceCategories; track mp; let i = $index) {
            <div class="cat-grid">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="cat-header">
                        <span>{{mp.name}}</span>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="board-list">
                    @for (mpsc of mp.marketplaceSubcategory; track mpsc) {
                      <div class="cat-content">
                        <div class="name">{{mpsc.name}}</div>
                        <div class="icons">
                          <mat-icon style="color: orange" (click)="editMarketplaceSubCategory(mpsc, mp.id)" class="sub-mat-icon">edit</mat-icon>
                          <mat-icon style="color: red" (click)="deleteMarketplaceSubCategory(mpsc.id, mp.id)" class="sub-mat-icon">clear</mat-icon>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="add-subcat" (click)="addMarketplaceSubCategory(mp.id)">{{'marketplaces.add_subcategory' | translate}}</div>
                </mat-expansion-panel>
              </mat-accordion>
              <mat-icon style="color: orange" (click)="editMarketplaceCategory(mp.id, mp.name)" class="main-mat-icon">edit</mat-icon>
              <mat-icon style="color: red" (click)="deleteMarketplaceCategory(mp.id)" class="main-mat-icon">clear</mat-icon>
            </div>
          }
        }
      </div>
      @if (!marketplaceCategories?.length) {
        <div class="no-data-msg">
          <span class="mat-headline-6">{{'main.noData' | translate}}</span>
        </div>
      }
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
